// extracted by mini-css-extract-plugin
export var searchHeader = "_6z-0";
export var searchHeaderDark = "_6z-1";